<template>
  <div id="country-comparison" class="title-container w-100 z-100 fixed-top text-white">
    <h1 class="title fs-3 m-0 p3-custom text-center fw-bold">Geographical Zone Comparison</h1>
  </div>
  <div class="d-flex flex-row bg-body-tertiary pt-9 pb-0 align-items-center">
        <template v-for="(tab, index) in tabs" :key="tab.code">
            <div @click="select(tab.code)" class="px-2" style="cursor: pointer">
                <div v-if="selected !== tab.code">
                    <h5>{{ tab.name }}</h5>
                </div>
                <div v-else class="border-bottom border-primary text-primary">
                    <h5>{{ tab.name }}</h5>
                </div>
            </div>

            <!-- Separator: only show if it's not the last tab -->
            <div
                v-if="index < tabs.length - 1"
                class="vr"
                style="height: 1.5rem;"
            >
            </div>
        </template>
    </div>

  <div v-if="selected=='single'">
    <SingleCriteria></SingleCriteria>
  </div>

  <div v-if="selected=='opportvsrisk'">
    <OpportVSRisk></OpportVSRisk>
  </div>

</template>

<script>
/* eslint-disable */
import SingleCriteria from '@/components/CountryComparison/SingleCriteria.vue'
import OpportVSRisk from '@/components/CountryComparison/OpportVSRisk.vue'

export default {
  components: {
    SingleCriteria,
    OpportVSRisk,
  },
  data() {
    return {
      regions: [],
      regionsorg: [],
      country: [],
      path: 'country-comparison',
      countriesData : {},
      indicatorSave: '',
      regionSave: '',
      receivedDataId: this.$route.params.indicator,
      receivedDataRe: this.$route.params.region,
      has_error: false,
      errorMessage: 'Please select an Indicator and a Region',
      tabs: [
        {name: 'Regional Comparison', code: 'single'},
        {name: 'Opportunity vs. Risk', code: 'opportvsrisk'},
      ],
      selected: "single"
    }
  },
  methods: {
    select(code){
      this.selected = code
    },
    triggerComparison() {
      // Call the methods that handle data from children
      this.$refs.menuDropDownRef.notifyChild();

      // Check if both receivedDataId and receivedDataRe are defined
      if (this.receivedDataId !== undefined && this.receivedDataRe !== undefined) {
        // Update the route and reload the page
        this.$router.push(`/${this.path}/${this.receivedDataRe}/${this.receivedDataId}`).then(() => {
          window.location.reload();
        });
      }
    },
    error(data) {
      this.has_error = data
    },
  },
  mounted() {
  }
}
</script>